import { Navigate, Outlet } from "react-router";
import { AUTH_STATUS, UserProvider, useUserContext } from "@/features/home/UserContext";

/**
 * Reads auth status from UserContext (always available — runs inside UserProvider).
 *
 * - "pending"         → <Outlet /> (HomePage renders its own skeletons)
 * - "authenticated"   → <Outlet />
 * - "unauthenticated" → redirect to /login
 */
function AuthGuard() {
  const { status } = useUserContext();

  if (status === AUTH_STATUS.UNAUTHENTICATED) {
    return <Navigate replace to="/login" />;
  }

  return <Outlet />;
}

/**
 * Wraps protected routes with UserProvider + AuthGuard.
 * UserProvider calls GET /v1/users/me once; child pages read from context via useMe().
 *
 * On unauthenticated: redirects to /login.
 * return-url.service only accepts absolute external URLs, so internal paths
 * like /home are not stored — LoginPage always navigates to /home on success.
 */
export function ProtectedRoute() {
  return (
    <UserProvider>
      <AuthGuard />
    </UserProvider>
  );
}
